query TrainingFolders(
  $orderBy: [TrainingFoldersOrderBy!]
  $filter: TrainingFolderFilter
) {
  trainingFolders(orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      name
      hint
      _subFolderCount
      _folderFileCount
      trainingFiles(orderBy: SORT_SEQUENCE_ASC) {
        nodes {
          id
          name
          hint
          iconType
        }
      }
      _childFolders(orderBy: SORT_SEQUENCE_ASC) {
        edges {
          node {
            id
            name
            hint
            _subFolderCount
            _folderFileCount
            trainingFiles(orderBy: SORT_SEQUENCE_ASC) {
              nodes {
                id
                name
                hint
                iconType
              }
            }
            _childFolders(orderBy: SORT_SEQUENCE_ASC) {
              nodes {
                id
                name
                hint
                _subFolderCount
                _folderFileCount
                trainingFiles(orderBy: SORT_SEQUENCE_ASC) {
                  nodes {
                    id
                    name
                    hint
                    iconType
                  }
                }
                _childFolders(orderBy: SORT_SEQUENCE_ASC) {
                  nodes {
                    id
                    name
                    hint
                    _subFolderCount
                    _folderFileCount
                    trainingFiles(orderBy: SORT_SEQUENCE_ASC) {
                      nodes {
                        id
                        name
                        hint
                        iconType
                      }
                    }
                    _childFolders(orderBy: SORT_SEQUENCE_ASC) {
                      nodes {
                        id
                        name
                        hint
                        _subFolderCount
                        _folderFileCount
                        trainingFiles(orderBy: SORT_SEQUENCE_ASC) {
                          nodes {
                            id
                            name
                            hint
                            iconType
                          }
                        }
                        _childFolders(orderBy: SORT_SEQUENCE_ASC) {
                          nodes {
                            id
                            name
                            hint
                            _subFolderCount
                            _folderFileCount
                            trainingFiles(orderBy: SORT_SEQUENCE_ASC) {
                              nodes {
                                id
                                name
                                hint
                                iconType
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
